import { nodeHasChildrenRenderedAsSiblings } from 'components/move-list/helpers/node-line-utils';

/**
 * handler to delete move
 */
export function deleteMove({ node, api }): void {
  const rawLines = api.getRawLines();

  // Because the variation rendering is slightly different than the actual line structure,
  // we have to replace the variation with a child instead of just deleting in some cases.
  if (node.ids.line !== 0 && node.lines && nodeHasChildrenRenderedAsSiblings(node, rawLines)) {
    api.promoteVariation(node.lines[0], 1, { replace: true });
    return;
  }

  api.deletePosition(node.ids.move, node.ids.line);
}
